import { render, staticRenderFns } from "./RulesTable.vue?vue&type=template&id=4dafd98b&scoped=true"
import script from "./RulesTable.vue?vue&type=script&lang=js"
export * from "./RulesTable.vue?vue&type=script&lang=js"
import style0 from "./RulesTable.vue?vue&type=style&index=0&id=4dafd98b&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dafd98b",
  null
  
)

export default component.exports